
import { IAskusAnswer, IAskusQuestion } from '@/models/askus.model';
import { defineComponent, PropType, onBeforeMount, ref } from 'vue';
import useConverter from '@/composables/general/useConverter';
import askusRepository from '@/api/askusRepository';
import { computed } from '@vue/reactivity';
import { askusStore } from '@/store/askus-store';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import AttributeShowList from '@/components/attribute/ShowList.vue';

export default defineComponent({
  // Prevents warning caused by the keep alive functionality.
  // Warnings included -> use of externious Props...etc
  inheritAttrs: false,
  name: 'AskusQuestion',
  props: {
    question: {
      type: Object as PropType<IAskusQuestion>,
      required: true,
    },
  },
  components: {
    WdwDynbox,
    AttributeShowList,
  },
  emits: ['openList'],
  setup(props, context) {
    const { formattedDate } = useConverter();
    const answers = computed(() => {
      return askusStore.getState().answers;
    });
    function openList() {
      askusStore.resetAnswers();
      context.emit('openList');
    }
    return {
      answers,
      formattedDate,
      openList,
    };
  },
});
